// accordionClasses.js
const classes = {
  // ACCORDION VARIABLES
  ACCORDION_ITEM: "accordion__item",
  ACCORDION_HEAD: "accordion__head",
  OPEN_ACCORDION: "open__accordion",

  // TAB VARIABLES
  TAB_CONTAINER: "tabs",

  // SLIDER VARIABLES
  SLIDER_INIT: "swiper",

  // LAZY LOAD BACKGROUND VARIABLES
  LAZY_LOAD_BG: "lazy-background",
  LAZY_LOAD_SRC: "lazy",
  LAZY_LOAD_SRC_LOADED: "loaded",

  //SELECT CUSTOM SELECT WITH MULTI SELECT AND SINGLE SELECT

  CUSTOM_SELECT: "custom-select",
  SELECT_BOX: "select-box",
  SELECT_INPUT: "select-input",
  DROPDOWN: "dropdown",
  DROPDOWN_SEARCH: "dropdown-search",
  DROPDOWN_OPTIONS: "dropdown-options",
  SELECTED_TAGS: "selected-tags",
  SELECTED_TAG: "selected-tag",
  SELECTED: "selected",
  DROPDOWN_ARROW: "dropdown-arrow",

  // select check and radio
  FORM_BLOCK: "form__block",
};

export default classes;
